<template>

    <div>
        <div class="form-horizontal form-light" role="form">
            <div class="input-group input-group-lg">
                <input type="text" class="form-control"
                       placeholder="Быстрый поиск категории. Примеры: Экскаватор, минипогрузчик, говновоз"
                       aria-describedby="sizing-addon1"
                       v-model="search_text" v-on:keyup="onSearch">

                <span class="input-group-addon btn btn-base" type="button" id="sizing-addon1">
                    <i class="fa fa-search" aria-hidden="true"></i>
                </span>
            </div>
        </div>

        <div v-if="results.result && results.result.length">
            <h4 id="results-text" style="margin-top:10px">Результат поиска для: <b
                id="search-string">{{ search_text }}</b></h4>

            <ul id="results">
                <li class="result" v-for="result in results.result" :key="result.id">
                    <a :href="(city_slug ? ('/' + city_slug) : '') + '/'+ (rent ? result.url_rent_general : result.url_sale_general)">
                        <div style="display: flex">
                            <img alt="" :src="'/images/machinery_icons/'+ result.id + '.jpg'" style="height: 70px">
                            <div style="margin-left: 15px">
                                <h4>{{ rent ? result.name_rent_general : result.name_sale_general }}</h4>
                                <h5>{{ rent ? result.bref_note_rent : result.bref_note_sale   }}</h5>
                            </div>
                        </div>
                    </a>
                </li>

            </ul>
        </div>
        <div v-else-if="results.result && !results.result.length">
            <h4 style="margin-top:10px">Ничего не найдено</h4>
            <h5>Попробуйте сформулировать иначе.</h5>

            
        </div>


    </div>
</template>

<script>
import debounce from "lodash/debounce";

export default {
    name: "TypeSearch",
    props: {
        city_slug: {
            type: String,
            required: true
        },
        rent: {
            type: Boolean,
            default: true
        }
    },
    data: function () {
        return {
            'search_text': '',
            'results': [],
        }
    },
    methods: {
        onSearch() {

            if (this.search_text.length > 3) {

                // axios.get(searchUrl + this.search_text).then(responce => {
                //     this.results = responce.data
                // });
                this.search(this.search_text, this);

                return;
            }

            this.results = [];

        },

        search: debounce((needle, vm) => {

            axios.get('/api/type/search/' + vm.search_text).then(response => {
                vm.results = response.data
            });

        }, 750)

    }
}
</script>

<style scoped>

</style>
